import { apiClient } from '../../gateways/api'
import type { FetchProjectdossierOrganisationLists } from '../types/FetchProjectdossierOrganisationLists'

export { fetchProjectdossierOrganisationLists, initialState }

const initialState: FetchProjectdossierOrganisationLists = {
  data: {
    verantwoordelijken: [],
    gebieden: [],
  },
}

const fetchProjectdossierOrganisationLists = async (): Promise<
  FetchProjectdossierOrganisationLists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/projectdossier/lists/organisation',
    method: 'GET',
  })
  return data
}
